import React from 'react';
import { AutoFocusedForm, composeValidators, Modal, moreThanZero, TextField } from 'components';
import { required } from 'components';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  createStyles,
  Divider,
  Grid,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { useUpdateProjectRequirementsForm } from './';
import { Field } from 'react-final-form';
import { MutableButton } from 'ui/MutableButton';
import { ProjectRequirements } from '../../../../schema';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '500px',
    },
    header: {
      fontWeight: 'bolder',
    },
    divider: {},
    content: {},
    actions: {
      justifyContent: 'flex-end',
    },
  })
);

type Props = {
  requirements: ProjectRequirements;
};

export const EditProjectRequirementsPopup = ({ requirements }: Props) => {
  const classes = useStyles();

  const { onCancel, initialValues, loading, onSubmit } = useUpdateProjectRequirementsForm({
    requirements,
  });

  return (
    <Modal
      onClose={onCancel}
      aria-labelledby="Изменение потребностей проекта"
      aria-describedby="Используйте эту форму для Изменения потребностей проекта"
    >
      <AutoFocusedForm
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, valid }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Card className={classes.root}>
                <CardHeader title="Изменение потребностей" />
                <Divider className={classes.divider} />
                <CardContent className={classes.content}>
                  <Grid container spacing={4}>
                    <Grid item lg={12} md={12} xl={12} xs={12}>
                      <Field
                        name="remainingDuration"
                        component={TextField}
                        label="Денег в фонде хватит на"
                        validate={required}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={4}>
                    <Grid item lg={12} md={12} xl={12} xs={12}>
                      <Field
                        name="estimatedMonthlyExpensesAmount"
                        label="Планируемые расходы проекта"
                        component={TextField}
                        validate={composeValidators(required, moreThanZero)}
                        type="number"
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions className={classes.actions}>
                  <MutableButton
                    loading={loading}
                    color="primary"
                    disabled={!valid}
                    size="medium"
                    type="submit"
                    variant="contained"
                  >
                    Сохранить
                  </MutableButton>
                  <Button
                    onClick={onCancel}
                    disabled={loading}
                    size="medium"
                    type="button"
                    variant="contained"
                  >
                    Отменить
                  </Button>
                </CardActions>
              </Card>
            </form>
          );
        }}
      />
    </Modal>
  );
};
